<p-dialog
  header="{{ isEdit ? 'Editar Moneda' : 'Nueva Moneda' }}"
  [(visible)]="visible"
  [responsive]="false"
  [style]="{ width: 'width', minWidth: 'minWidth' }"
  [maximizable]="false"
  [draggable]="false"
  [resizable]="false"
  [formGroup]="monedaForm"
>
  <br />
  <div class="form-row">
    <!-- MONEDA -->
    <div class="form-field col-3">
      <input [maxlength]="2" pInputText type="text" formControlName="moneda" class="form-control" [placeholder]="'Ingrese Moneda'" appPermissionControl="P109K0001" />
      <label>Moneda</label>
    </div>

    <!-- DESCRIPCION -->
    <div class="form-field">
      <input pInputText type="text" formControlName="descripcion" class="form-control" [placeholder]="'Ingrese Descripción'" appPermissionControl="P109K0002" />
      <label>Descripción</label>
    </div>
  </div>

  <div class="form-row">
    <!-- FACTOR -->
    <div class="form-field">
      <input pInputText type="number" formControlName="factor" class="form-control" [placeholder]="'Ingrese Factor'" appPermissionControl="P109K0003" />
      <label>Factor</label>
    </div>

    <!-- FECHA -->
    <div class="form-field">
      <input pInputText type="date" appendTo="body" formControlName="fecha" class="form-control" appPermissionControl="P109K0004" />
      <label>Fecha</label>
    </div>

    <!-- RESPONSABLE -->
    <div class="form-field">
      <input pInputText type="text" formControlName="responsable" class="form-control" [placeholder]="'Ingrese Responsable'" appPermissionControl="P109K0005" />
      <label>Responsable</label>
    </div>
  </div>

  <div class="d-flex gap-2 justify-content-left">
    <button mat-flat-button (click)="save()" class="btn-success" [disabled]="!monedaForm.valid" appPermissionControl="P109B0001">
      <mat-icon>save</mat-icon>
      {{ isEdit ? 'Actualizar' : 'Guardar' }}
    </button>
    <button mat-flat-button class="btn-search" (click)="customizables()" *ngIf="isEdit" appPermissionControl="P109B0002">
      <mat-icon>receipt</mat-icon>
      Customizables
    </button>
    <button mat-flat-button class="btn-search" (click)="paridades()" *ngIf="isEdit" appPermissionControl="P109B0003">
      <mat-icon>balance</mat-icon>
      Paridades
    </button>
  </div>
</p-dialog>
